import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { utils } from '@enso/components';
import theme from '../theme';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background-color: ${props => props.theme.color.backgroundWhite};

  @media ${utils.device.laptop} {
    padding: 20px 140px;
  }
`;

const Logo = styled.img`
  height: 40px;
`;

const Nav = styled.nav`
  display: flex;
  gap: 32px;
  align-items: center;
`;

const NavLink = styled.span`
  font-family: ${props => props.theme.font.body};
  font-size: 14px;
  color: ${props => props.theme.color.textDark};
  text-decoration: none;
  font-weight: bold;
`;

HeaderContainer.defaultProps = { theme };
NavLink.defaultProps = { theme };

const Header = function() {
  return (
    <HeaderContainer>
      <Link to="/">
        <Logo src="/images/logo-enso.svg" alt="Enso logo" />
      </Link>
      <Nav>
        <NavLink>Tarjeta</NavLink>
        <NavLink>Wallet</NavLink>
        <NavLink>Nosotros</NavLink>
        <NavLink>Ayuda</NavLink>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;
